import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CookiePolicyPage = () => {
  useEffect(() => {
    // Load Iubenda script
    const script = document.createElement('script');
    script.src = 'https://cdn.iubenda.com/iubenda.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[src="https://cdn.iubenda.com/iubenda.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      {/* Header */}
      <header className="bg-[#4A7C59] py-4 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link to="/" className="text-white hover:text-white/80 transition-colors">
            <ArrowLeft className="w-6 h-6" />
          </Link>
          <h1 className="text-xl font-bold text-white">Cookie Policy</h1>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
          {/* Iubenda Embed */}
          <a 
            href="https://www.iubenda.com/privacy-policy/64056428/cookie-policy" 
            className="iubenda-nostyle iubenda-noiframe iubenda-embed iub-body-embed" 
            title="Cookie Policy"
          >
            Cookie Policy
          </a>
        </div>

        {/* Back link */}
        <div className="mt-8 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#4A7C59] hover:text-[#3A6345] font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna alla Home
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 px-4 text-center text-sm text-[#64748B]">
        <p>© 2026 CuraCheck - A.M.D. GENERAL HOLDING S.R.L.S.</p>
      </footer>
    </div>
  );
};

export default CookiePolicyPage;
